<template>
  <div class="fields__field fields__field--input" :class="{ '-error': error && !value }">
    <div class="field__label">
      <label class="control-label" :for="identifier" :class="{'bold': bold}">{{ label }}</label>
    </div>
    <div class="field__input">
      <span></span>
      <input :id="identifier" class="form-control" :class="{ '-filled': value }" type="text" :name="identifier" :value="value" @input="$emit('input', $event.target.value)">
    </div>
  </div>
</template>

<script>
export default {
  props: ['identifier', 'value', 'error', 'label', 'bold']
}
</script>
